import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Button,
  Typography,
} from '@mui/material';
import SendRoundedIcon from '@mui/icons-material/SendRounded';
import WebRoundedIcon from '@mui/icons-material/WebRounded';
import CounterWithLabel from '../../../../../Components/CaptionValue/CounterWithLabel';
import capitalize from '../../../../../Helpers/StringsFormatting/capitalize';
import EditorContent from '../../Shared/EditorContent';

const SmsTextArea = function SmsTextArea({
  template = null,
  onChangeTemplate = () => {},
  dynamicElement = null,
}) {
  const intl = useIntl();
  return (
    <Card
      raised
      sx={{
        width: '80%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'visible',
        padding: '16px 36px 24px 36px',
        marginBottom: '24px',
      }}
    >
      <CardHeader
        disableTypography
        avatar={<WebRoundedIcon sx={{ opacity: 0.54, fontSize: '2.5rem' }} />}
        title={
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Typography variant="h4" sx={{ opacity: 0.54 }}>
              {capitalize(template?.name) || intl.messages.UNAVAILABLE}
            </Typography>
            <CounterWithLabel
              reverse
              label={intl.messages.CHARS}
              labelVariant="h5"
              value={template?.content?.length}
              title={intl.messages.EXCLUDED_DYNAMIC_ELEMENTS}
            />
          </div>
        }
      />
      <CardContent
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          gap: '24px',
          p: 0,
        }}
      >
        <EditorContent
          id="sms-content"
          style={{
            outline: '1px solid #c6c6c6',
            height: '240px',
            borderRadius: 5,
            overflow: 'auto',
            overflowX: 'hidden',
            whiteSpace: 'break-spaces',
            color: 'inherit',
          }}
          dynamicElement={dynamicElement}
          templateName={template?.name}
          content={template?.content}
          onChange={onChangeTemplate}
          plainTextOnly
          edit
        />
      </CardContent>
      <CardActions sx={{ justifyContent: 'flex-end', p: 0, pt: '24px' }}>
        <Button
          disabled
          id="send-test-btn"
          variant="contained"
          endIcon={<SendRoundedIcon />}
          onClick={() => {}}
        >
          {intl.messages.SEND_TEST}
        </Button>
      </CardActions>
    </Card>
  );
};

SmsTextArea.propTypes = {
  template: PropTypes.object,
  onChangeTemplate: PropTypes.func,
  dynamicElement: PropTypes.object,
};
export default SmsTextArea;
